import videojs from "video.js";
const dom = videojs.dom;

/**
 * @typedef {Object} StickerOptions
 * @property {number} displayIntervalTime - The interval time in milliseconds for sticker display
 * @property {StickerPosition} position - The position of the sticker in pixels
 * @property {string} stickerLinkTo - The link the sticker should navigate to when clicked
 * @property {string} stickerUrl - The URL of the sticker image
 * @property {StickerDisplayTime} displayTime - The display time configuration for the sticker
 */

/**
 * @typedef {Object} StickerPosition
 * @property {number | undefined} top - The top position of the sticker in pixels
 * @property {number | undefined} left - The left position of the sticker in pixels
 * @property {number | undefined} bottom - The bottom position of the sticker in pixels
 * @property {number | undefined} right - The right position of the sticker in pixels
 */

/**
 * @typedef {Object} StickerDisplayTime
 * @property {number} intervalTime - The interval time for displaying the sticker in milliseconds
 * @property {number} timeoutTime - The timeout time for hiding the sticker in milliseconds
 */

videojs.registerComponent("Sticker", class extends videojs.getComponent("Component") {
  /**
   * Constructor for the Sticker component
   * @param {videojs.Player} player - The Video.js player instance
   * @param {StickerOptions} options - The options for the Sticker component
  */
  constructor(player, options) {
    super(player, options);
    this.options_ = options;

    this.stickerDisplayTimeoutId = null;
    this.stickerHidingTimeoutId = null;
    this.stickerStartTimeoutId = null;
    this.setListeners();

    if (this.options_.displayTime) {
      this.startStickerDisplay(this.options_.displayTime);
    }
  }

  setListeners() {
    this.player().on("play", () => {
      if (this.options_.displayTime) {
        this.startStickerDisplay(this.options_.displayTime);
        return;
      }

      this.show();
    });

    this.player().on(["pause", "ended"], () => {
      this.hide();
      this.player().clearTimeout(this.stickerDisplayTimeoutId);
      this.player().clearTimeout(this.stickerHidingTimeoutId);
      this.player().clearTimeout(this.stickerStartTimeoutId );
    })
  }

  startStickerDisplay(displayTime) {
    const { timeoutTime, intervalTime, startTime } = displayTime;

    this.stickerStartTimeoutId  = this.player().setTimeout(() => {
      this.iterationSticker(timeoutTime, intervalTime);
    }, startTime);
  }

  iterationSticker(timeoutTime, intervalTime) {
    this.show();

    this.stickerHidingTimeoutId = this.player().setTimeout(() => {
      this.hide();

      this.stickerDisplayTimeoutId = this.player().setTimeout(() => {
        this.iterationSticker(timeoutTime, intervalTime); // Запускаем новую итерацию после скрытия
      }, intervalTime);

    }, timeoutTime);
  }

  createEl() {
    const stickerContainerEl = dom.createEl("div", {
      className: "vjs-promo-sticker vjs-hidden",
      style: this.options_.position
    });

    const stickerLinkEl = dom.createEl("a", {
      className: "vjs-promo-sticker__link",
      target: "_blank",
      href: this.options_.stickerLinkTo
    });

    const imageStickerEl = dom.createEl("img", {
      className: "vjs-promo-sticker__image",
      src: this.options_.stickerUrl
    });

    stickerLinkEl.append(imageStickerEl);
    stickerContainerEl.append(stickerLinkEl);

    return stickerContainerEl;
  }
});